import MatrixAnalysisWidget from "./MatrixAnalysisWidget";
import MatrixAnalysis from "../presentation/MatrixAnalysis";
import React from "react";

class StartupAnalysisWidget extends MatrixAnalysisWidget {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <StartupAnalysis
                navigator={this.props.navigator}
                loadData={this.state}
                updateTableByPlatform={this.updateTableByPlatform}
                toggleDisplayAsIcons={this.toggleDisplayAsIcons}
                toggleShowSinglePercentage={this.toggleShowSinglePercentage}
                toggleSelectDevice={this.toggleSelectDevice}
                toggleSelectZone={this.toggleSelectZone}
                toggleShowZone={this.toggleShowZone}
                toggleShowAllZones={this.toggleShowAllZones}
                toggleShowDevice={this.toggleShowDevice}
                toggleShowAllDevices={this.toggleShowAllDevices}
                updateDevicesSortState={this.updateDevicesSortState}
                updateZonesSortState={this.updateZonesSortState}
                toggleShowPanels={this.toggleShowPanels}
                toggleReadTriggersDataFromLogs={this.toggleReadTriggersDataFromLogs}
                setTTTMetric={this.setTTTMetric}
            />
        ); //return
    } //render
}